import React, { useEffect, useMemo, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { all_routes } from "../router/all_routes";
import CollapseHeader from "../../core/common/collapse-header/collapse-header";
import Table from "../../core/common/dataTable/index";
import ImageWithBasePath from "../../core/common/imageWithBasePath";
import TrainingListModal from "../../core/modals/trainingListModal";
import { useSelector, useDispatch } from "react-redux";
import { AppDispatch } from "../../core/data/redux/store";
import {
  fetchAlltraininglist,
  deletetraininglistById,
} from "../../core/data/redux/training/trainingAction";
import DeleteModal1 from "../../core/modals/deleteModal1";
import { filterData } from "../../core/common/GlobalFunctions/tableFilters";
import { filterByStatus } from "../../core/utils/filterActiveData";
import { message } from "antd";
import { decryptData } from "../../core/utils/encryptUtils";

const TrainingList = () => {
  const dispatch = useDispatch<AppDispatch>();
  const [selectedSort, setSelectedSort] = useState<any>("Recently Added");
  const [selectedStatus, setSelectedStatus] = useState("active");
  const [isDeleteModalVisible, setIsDeleteModalVisible] =
    useState<boolean>(false);
  const [isEditing, setIsEditing] = useState(false);
  const [isDrawerVisible, setIsDrawerVisible] = useState(false);
  const [selectedRowData, setSelectedRowData] = useState<any>();
  const Id = selectedRowData?.Id;
  const { Training } = useSelector((state: any) => state.training.training);
  const routes = all_routes;
  const data = Training;

  const handleAddTraining = () => {
    setSelectedRowData(null);
    setIsEditing(false);
  };

  const handleEditTraining = (record: any) => {
    setSelectedRowData(record);
    setIsEditing(true);
  };

  useEffect(() => {
    dispatch(fetchAlltraininglist());
  }, [dispatch, isEditing, isDrawerVisible]);


  const encryptedPermissions = localStorage.getItem('currentPermissions');
  const permissions: string[] = Array.isArray(decryptData(encryptedPermissions || '')) ? decryptData(encryptedPermissions || '') : [];

  const canAdd =
    permissions.includes("Add") || permissions.includes("AllowAll");
  const canView =
    permissions.includes("View") || permissions.includes("AllowAll");
  const canEdit =
    permissions.includes("Edit") || permissions.includes("AllowAll");
  const canDelete =
    permissions.includes("Delete") || permissions.includes("AllowAll");
  const canExport =
    permissions.includes("Export") || permissions.includes("AllowAll");


  const [tableKey, setTableKey] = useState(0);

  const filteredData = useMemo(() => {
    const filters =
      selectedStatus && selectedStatus !== "All"
        ? { Status: selectedStatus }
        : {};
    return filterData(
      data || [],
      filters,
      "CreatedAt",
      "CreatedAt",
      selectedSort
    );
  }, [dispatch, Training, selectedSort, selectedStatus]);

  useEffect(() => {
    setTableKey((prevKey) => prevKey + 1);
  }, [dispatch, Training, selectedSort, selectedStatus]);

  const handleDeletePolicy = (Id: any) => {
    const TerminationId = Id;
    dispatch(deletetraininglistById({ id: TerminationId }))
      .then((resp: any) => {
        if (resp.meta.requestStatus === "fulfilled") {
          setIsDeleteModalVisible(false);
          message.success(resp.payload.message);
          dispatch(fetchAlltraininglist());
        } else {
          setIsDeleteModalVisible(false);
          message.warning(resp.payload.error);
        }
      })
      .catch((error: any) => {
        console.error("error is ", error);
      });
  };

  const columns = [
    {
      title: "Training",
      dataIndex: "Name",
      render: (text: any) => text || "None",
      sorter: (a: any, b: any) => {
        const aType = a.Name || "";
        const bType = b.Name || "";
        return aType.length - bType.length;
      },
    },
    {
      title: "Trainer",
      dataIndex: "Trainername",
      render: (text: any) => text || "None",
      sorter: (a: any, b: any) => {
        const aType = a.Trainername || "";
        const bType = b.Trainername || "";
        return aType.length - bType.length;
      },
    },
    {
      title: "Training Type",
      dataIndex: "Trainingtypename",
      render: (text: string, record: any) => (
        <div className="d-flex align-items-center file-name-icon">
          {/* <Link to="#" className="avatar avatar-md border avatar-rounded">
            <ImageWithBasePath
              src={`assets/img/users/${record.Image}`}
              className="img-fluid"
              alt="img"
            />
          </Link> */}
          <div className="ms-2">
            <h6 className="fw-medium">
              <Link to="#">{text}</Link>
            </h6>
          </div>
        </div>
      ),
      sorter: (a: any, b: any) =>
        a.Trainingtypename.length - b.Trainingtypename.length,
    },
    {
      title: "Employee",
      dataIndex: "Employee",
      render: (_text: string, record: any) => {
       
        let attendees: number[] = [];
        try {
          attendees = JSON.parse(record.Attendees || "[]");
        } catch {
          attendees = [];
        }
        const pictureUrls = record.AttendeePictures
          ? record.AttendeePictures.split(",").map((url: string) => url.trim())
          : [];

        return (
          <div className="avatar-list-stacked avatar-group-sm">
            {pictureUrls.length > 0 ? (
              pictureUrls.map((url: string, index: number) => (
                <img
                  key={index}
                  src={url}
                  alt={`Attendee ${index + 1}`}
                  className="avatar rounded-circle me-1 border"
                  style={{
                    width: "30px",
                    height: "30px",
                    objectFit: "cover",
                  }}
                  title={`Employee: ${record.AttendeeNames?.split(",")[index]?.trim() || "Unknown"
                    }`}
                />
              ))
            ) : (
              <span className="text-muted">No Attendees</span>
            )}
          </div>
        );
      },
      sorter: (a: any, b: any) => {
        const aCount = JSON.parse(a.Attendees || "[]").length;
        const bCount = JSON.parse(b.Attendees || "[]").length;
        return aCount - bCount;
      },
    },
    {
      title: "Time Duration",
      dataIndex: "TotalDuration",
      sorter: (a: any, b: any) =>
        a.TotalDuration.length - b.TotalDuration.length,
    },
    {
      title: "Description",
      dataIndex: "Description",
      sorter: (a: any, b: any) => a.Description.length - b.Description.length,
    },
    {
      title: "Cost",
      dataIndex: "Cost",
      sorter: (a: any, b: any) => a.Cost.length - b.Cost.length,
    },
    {
      title: "Status",
      dataIndex: "Status",
      render: (text: string) => {
        const badgeClass =
          text.toLowerCase() === "active"
            ? "badge-success"
            : text.toLowerCase() === "inactive"
              ? "badge-danger"
              : "badge-secondary"; // fallback color

        return (
          <span
            className={`badge ${badgeClass} d-inline-flex align-items-center badge-xs`}
          >
            <i className="ti ti-point-filled me-1" />
            {text ? text.charAt(0).toUpperCase() + text.slice(1) : ""}

          </span>
        );
      },
      sorter: (a: any, b: any) => a.Status.length - b.Status.length,
    },
    {
      title: "Action",
      dataIndex: "actions",
      render: (text: string, record: any) => (
        <div className="action-icon d-inline-flex">
          {/* Edit Icon - Always visible, but disabled if canEdit is false */}
          <Link
            to="#"
            onClick={(e) => {
              if (!canEdit) {
                e.preventDefault();
                return;
              }
              setIsEditing(true);
              setIsDrawerVisible(true);
            }}
            style={{
              pointerEvents: canEdit ? "auto" : "none",
              cursor: canEdit ? "pointer" : "not-allowed",
              opacity: canEdit ? 1 : 0.5,
            }} data-bs-toggle="tooltip"
            data-bs-placement="top"
            title="Edit"
          >
            <i
              className="ti ti-edit"
              onClick={() => {
                if (canEdit) handleEditTraining(record);
              }}
            />
          </Link>

          {/* Delete Icon - Always visible, disabled if canDelete is false or status is inactive */}
          <Link
            to="#"
            onClick={(e) => {
              if (!(canDelete && record.Status !== "inactive")) {
                e.preventDefault();
                return;
              }
              setSelectedRowData(record);
              setIsDeleteModalVisible(true);
            }}
            style={{
              pointerEvents:
                canDelete && record.Status !== "inactive" ? "auto" : "none",
              cursor:
                canDelete && record.Status !== "inactive"
                  ? "pointer"
                  : "not-allowed",
              opacity:
                canDelete && record.Status !== "inactive" ? 1 : 0.5,
            }} data-bs-toggle="tooltip"
            data-bs-placement="top"
            title="Delete"
          >
            <i className="ti ti-trash" />
          </Link>
          {/* <button
            disabled={!canView}
            onClick={() => {
              if (!canView) return;
              setIsDrawerVisible(true);
              setSelectedRowData(record);
            }}
            style={{
              cursor: canView ? "pointer" : "not-allowed",
              opacity: canView ? 1 : 0.5,
            }} data-bs-toggle="tooltip"
            data-bs-placement="top"
            title="Employee log"
          >
            <i className="ti ti-clock" />
          </button> */}
        </div>
      ),
    },
  ];
  return (
    <>
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          {/* Breadcrumb */}
          <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
            <div className="my-auto mb-2">
              <h2 className="mb-1">Training</h2>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={routes.adminDashboard}>
                      <i className="ti ti-smart-home" />
                    </Link>
                  </li>
                  <li className="breadcrumb-item">Training</li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Add Training
                  </li>
                </ol>
              </nav>
            </div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap ">
              {canAdd && (
                <div className="mb-2">
                  <Link
                    to="#"
                    className="btn btn-primary d-flex align-items-center"
                    onClick={() => {
                      setIsEditing(false);
                      setSelectedRowData(null);
                      setIsDrawerVisible(true);
                    }}
                  >
                    <i className="ti ti-circle-plus me-2" />
                    Add Training{" "}
                  </Link>
                </div>
              )}
              <div className="head-icons ms-2">
                <CollapseHeader />
              </div>
            </div>
          </div>
          <div className="card">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
              <h5>Training List</h5>
              <div className="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-3">
                <div className="dropdown me-3">
                  <Link
                    to="#"
                    className="dropdown-toggle btn btn-sm btn-white d-inline-flex align-items-center"
                    data-bs-toggle="dropdown"
                  >
                    {selectedStatus
                      ? selectedStatus.charAt(0).toUpperCase() +
                      selectedStatus.slice(1)
                      : "Select Status"}
                  </Link>
                  <ul className="dropdown-menu  dropdown-menu-end p-3">
                    <li>
                      <Link
                        to="#"
                        onClick={() => setSelectedStatus("All")}
                        className="dropdown-item rounded-1"
                      >
                        All
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        onClick={() => setSelectedStatus("active")}
                        className="dropdown-item rounded-1"
                      >
                        Active
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        onClick={() => setSelectedStatus("inactive")}
                        className="dropdown-item rounded-1"
                      >
                        Inactive
                      </Link>
                    </li>
                  </ul>
                </div>
                <div className="dropdown">
                  <Link
                    to="#"
                    className="dropdown-toggle btn btn-sm btn-white d-inline-flex align-items-center"
                    data-bs-toggle="dropdown"
                  >
                    {selectedSort
                      ? `Sort By : ${selectedSort}`
                      : "Sort By : Last 7 Days"}
                  </Link>
                  <ul className="dropdown-menu dropdown-menu-end p-3">
                    <li>
                      <Link
                        to="#"
                        onClick={() => setSelectedSort("Recently Added")}
                        className="dropdown-item rounded-1"
                      >
                        Recently Added
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        onClick={() => setSelectedSort("Ascending")}
                        className="dropdown-item rounded-1"
                      >
                        Ascending
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        onClick={() => setSelectedSort("Descending")}
                        className="dropdown-item rounded-1"
                      >
                        Descending
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        onClick={() => setSelectedSort("Last Month")}
                        className="dropdown-item rounded-1"
                      >
                        Last Month
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        onClick={() => setSelectedSort("Last 7 Days")}
                        className="dropdown-item rounded-1"
                      >
                        Last 7 Days
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="card-body p-0">
              <Table
                key={tableKey}
                dataSource={filteredData}
                columns={columns}
                Selection={true}
              />
            </div>
          </div>
          {/* /Performance Indicator list */}
        </div>
        <div className="footer d-sm-flex align-items-center justify-content-between border-top bg-white p-3">
          <p className="mb-0">2024 - 2025© hrmtree.</p>
          <p>
            Developed By{" "}
            <Link to="#" className="text-primary">
              Leadchain Systems
            </Link>
          </p>
        </div>
      </div>

      <TrainingListModal
        selectedRowData={selectedRowData}
        isEditing={isEditing}
        isDrawerVisible={isDrawerVisible}
        setIsDrawerVisible={setIsDrawerVisible}
      />

      <DeleteModal1
        isVisible={isDeleteModalVisible}
        onClose={() => setIsDeleteModalVisible(false)}
        onConfirm={() =>
          selectedRowData?.Id && handleDeletePolicy(selectedRowData?.Id)
        }
      />
    </>
  );
};

export default TrainingList;
